import { Box } from '@chakra-ui/react';
import { RefObject } from 'react';

interface FieldEditIndicatorProps {
  children: React.ReactNode;
  fieldRef: RefObject<HTMLDivElement>;
  isFieldBeingEdited: boolean;
  activeFieldRef: RefObject<HTMLDivElement> | null;
  left?: string;
  top?: string;
  width?: string;
  show?: boolean;
}

const FieldEditIndicator = ({
  children,
  fieldRef,
  width,
}: FieldEditIndicatorProps) => {
  return (
    <Box position="relative" ref={fieldRef} width={width}>
      {children}
    </Box>
  );
};

export default FieldEditIndicator;
